module.exports = __webpack_public_path__ + "static/media/vanilla.d652efba.JPG";